// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`<Text /> displays the text given 1`] = `
<p
  class="hyphens textRegular16 brandBlue500 scale"
  data-testid="text"
>
  some text
</p>
`;

exports[`<Text /> when additional props are included includes the relevant classes on the element 1`] = `
<h1
  class="hyphens display20 nomargin bold underline brandRed500 centerAlign hideOverflow uppercase strikeThrough tight"
  data-testid="text"
>
  <span
    style="transform: rotate(-5deg); display: inline-flex;"
  >
    s
  </span>
  <span
    style="transform: rotate(5deg); display: inline-flex;"
  >
    o
  </span>
  <span
    style="transform: rotate(-5deg); display: inline-flex;"
  >
    m
  </span>
  <span
    style="transform: rotate(5deg); display: inline-flex;"
  >
    e
  </span>
  <span
    style="transform: rotate(-5deg); display: inline-flex; min-width: 4px;"
  >
     
  </span>
  <span
    style="transform: rotate(5deg); display: inline-flex;"
  >
    t
  </span>
  <span
    style="transform: rotate(-5deg); display: inline-flex;"
  >
    e
  </span>
  <span
    style="transform: rotate(5deg); display: inline-flex;"
  >
    x
  </span>
  <span
    style="transform: rotate(-5deg); display: inline-flex;"
  >
    t
  </span>
</h1>
`;
